import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APIKEY_ROUTE } from "./apikey.constant";

// Lazy imports
const ApiKeyList = Loadable(
  lazy(() =>
    import("./ApiKeyList").then(({ ApiKeyList }) => ({
      default: ApiKeyList,
    }))
  )
);

const ManageApiKey = Loadable(
  lazy(() =>
    import("./ManageApiKey").then(({ ManageApiKey }) => ({
      default: ManageApiKey,
    }))
  )
);

export const apiKeyRoutes = [
  {
    path: APIKEY_ROUTE,
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.APIKEYS]}
      >
        <ApiKeyList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APIKEY_ROUTE}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.APIKEYS]}
      >
        <ManageApiKey />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APIKEY_ROUTE}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute
        
        moduleIds={[ALLOWED_MODULES.APIKEYS]}
      >
        <ManageApiKey />
      </AuthorizedRoute>
    ),
  },
];
